import { Controller } from 'react-hook-form';
import { Checkbox } from '@fasstech/middle-design-system';
import { propEq, is } from 'ramda';

const ControlledCheckboxGroup = ({
  name,
  form,
  options,
  rules = {},
  containerClassName = '',
  isDisplayed = true,
  extraOnChange,
  ...extraProps
}) => {
  if (!isDisplayed) {
    return null;
  }

  const onChange = (field, value) => () => {
    field.onChange(value);

    if (is(Function, extraOnChange)) {
      extraOnChange(value);
    }
  };

  return (
    <div className={`w-full md:w-[100%]! ${containerClassName}`}>
      {options.map(({ value, label }) => (
        <Controller
          key={`${name}-${value}`}
          name={name}
          control={form.control}
          rules={rules}
          render={({ field }) => (
            <div className="flex items-center gap-x-2">
              <Checkbox
                checked={propEq('value', value, field)}
                onClick={onChange(field, value)}
                {...extraProps}
              />
              <label onClick={onChange(field, value)}>{label}</label>
            </div>
          )}
        />
      ))}
    </div>
  );
};

export default ControlledCheckboxGroup;
